
import { defineComponent, PropType } from "vue";

export default defineComponent({
    name: "MessageInputChoices",
    props: {
        choices: {
            type: Array as PropType<string[]>,
            required: true
        }
    },
    methods: {
        onClick(choiceIndex: number) {
            const chosen = this.$refs[`choice${choiceIndex}`] as Array<HTMLButtonElement>
            this.$emit("chosen", chosen[0])
        }
    },
    mounted() {
        const defaultChoice = this.$refs.choice0 as Array<HTMLButtonElement>
        defaultChoice[0].focus()
    }
});
